// removed by extract-text-webpack-plugin
module.exports = {"tick-icon":"style__tick-icon___3buHG","cross-icon":"style__cross-icon___1qu2l","container":"style__container___3InCC","container--clickable":"style__container--clickable___26lqy"};


//////////////////
// WEBPACK FOOTER
// ./components/BooleanIcon/style.scss
// module id = 1359
// module chunks = 0